// Shared pagination UI generator matching App analytics Episode Breakdown
// Exports a function to attach pagination behavior to a container with
// prev/next anchors and a page-number container.

export function attachSlidingPagination(opts) {
  const {
    getState,          // () => { current_page, total_pages }
    setPage,           // (page:number) => void (should trigger fetch + rerender)
    containerId = 'pagination',
    prevId = 'prevPageBtn',
    nextId = 'nextPageBtn',
    windowSize = 3,
  } = opts || {};

  const container = document.getElementById(containerId);
  const prev = document.getElementById(prevId);
  const next = document.getElementById(nextId);
  if (!container || !prev || !next || !getState || !setPage) return;

  const { current_page, total_pages } = getState();
  const total = Number(total_pages) || 1;
  const current = Math.min(Math.max(1, Number(current_page) || 1), total);

  let start = current - windowSize;
  let end = current + windowSize;
  if (start < 1) { end += (1 - start); start = 1; }
  if (end > total) { start -= (end - total); end = total; }

  const pages = [];
  if (start > 1) { pages.push(1); if (start > 2) pages.push('...'); }
  for (let i = Math.max(1, start); i <= Math.min(total, end); i++) pages.push(i);
  if (end < total) { if (end < total - 1) pages.push('...'); pages.push(total); }

  let html = '';
  pages.forEach(p => {
    if (p === '...') {
      html += '<span class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>';
    } else {
      const active = (p === current);
      const cls = active
        ? 'relative z-10 inline-flex items-center bg-indigo-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
        : 'relative hidden items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 md:inline-flex';
      html += `<a href="javascript:void(0)" data-page="${p}" class="${cls}">${p}</a>`;
    }
  });
  container.innerHTML = html;

  container.querySelectorAll('a[data-page]').forEach(a => {
    a.addEventListener('click', ev => {
      ev.preventDefault();
      const p = Number(a.dataset.page) || 1;
      if (p !== current) setPage(p);
    });
  });

  const prevDisabled = current <= 1;
  const nextDisabled = current >= total;
  prev.classList.toggle('opacity-50', prevDisabled);
  prev.classList.toggle('pointer-events-none', prevDisabled);
  next.classList.toggle('opacity-50', nextDisabled);
  next.classList.toggle('pointer-events-none', nextDisabled);
  prev.onclick = ev => { ev.preventDefault(); if (!prevDisabled) setPage(current - 1); };
  next.onclick = ev => { ev.preventDefault(); if (!nextDisabled) setPage(current + 1); };
}

